import React from 'react';
import { Typography } from '@drone-js/core';
import AgodaMarkdown from 'component/common/AgodaMarkdown/AgodaMarkdown';
import { MarkdownListStyled } from 'component/common/AgodaMarkdown/MarkdownList.styled';

interface AdditionalInfoListsProps {
    additionalInformation: string[];
    contentLocale: string;
}

const AdditionalInfoLists: React.FC<AdditionalInfoListsProps> = (props) => {
    return (
        <MarkdownListStyled data-element-name="activities-details-additional-info" data-testid="activities-details-additional-info">
            {props.additionalInformation.map(
                (info) =>
                    info && (
                        <li key={info}>
                            <Typography lang={props.contentLocale}>
                                <AgodaMarkdown input={info} />
                            </Typography>
                        </li>
                    ),
            )}
        </MarkdownListStyled>
    );
};
AdditionalInfoLists.displayName = 'AdditionalInfoLists';

export default AdditionalInfoLists;
